import React, { useEffect, useState } from "react";
import packageJson from "../../../package.json";

type PackageRow = {
  name: string;
  installed: string;
  latest: string;
  stable: string;
  hasUpdate: boolean;
};

const ALLOWED_EMAIL = "krr2@eurofinsanz.com";

const jwt: any = localStorage.getItem('token');
const labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;

const PackageVersionDashboard = () => {
  const [rows, setRows] = useState<PackageRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);

  const fetchPackageInfo = async (pkg: string) => {
    try {
      const res = await fetch(`https://registry.npmjs.org/${pkg}`);
      const data = await res.json();

      return {
        latest: data["dist-tags"]?.latest || "N/A",
        stable: data["dist-tags"]?.latest || "N/A",
      };
    } catch {
      return {
        latest: "N/A",
        stable: "N/A",
      };
    }
  };

  const checkPackages = async () => {
    setLoading(true);

    const deps = packageJson.dependencies || {};
    const devDeps = packageJson.devDependencies || {};

    const allDeps = {
      ...deps,
      ...devDeps,
    };

    const results: PackageRow[] = await Promise.all(
      Object.entries(allDeps).map(async ([name, installed]) => {
        const info = await fetchPackageInfo(name);

        return {
          name,
          installed,
          latest: info.latest,
          stable: info.stable,
          hasUpdate: installed !== info.latest,
        };
      })
    );

    setRows(results);
    setLoading(false);
  };

  useEffect(() => {
    // 🔐 ACCESS CONTROL CHECK
    if (labUserCheck?.Email === ALLOWED_EMAIL) {
      setIsAllowed(true);
      checkPackages();

      const interval = setInterval(() => {
        checkPackages();
      }, 60 * 60 * 1000);

      return () => clearInterval(interval);
    } else {
      setIsAllowed(false);
    }
  }, [labUserCheck]);

  // 🚫 BLOCK UI IF NOT ALLOWED
  if (!isAllowed) {
    return (
      <div style={{ padding: 20, color: "red", fontWeight: "bold" }}>
        🚫 Access Denied. You are not authorized to view this page.
      </div>
    );
  }

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>📦 Package Version Dashboard</h2>

      {loading && <p>Loading packages...</p>}

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "20px",
        }}
      >
        <thead>
          <tr style={{ background: "#f5f5f5" }}>
            <th style={{ border: "1px solid #ddd", padding: 10 }}>Package</th>
            <th style={{ border: "1px solid #ddd", padding: 10 }}>
              Installed
            </th>
            <th style={{ border: "1px solid #ddd", padding: 10 }}>Latest</th>
            <th style={{ border: "1px solid #ddd", padding: 10 }}>Stable</th>
            <th style={{ border: "1px solid #ddd", padding: 10 }}>Status</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row) => (
            <tr key={row.name}>
              <td style={{ border: "1px solid #ddd", padding: 10 }}>
                {row.name}
              </td>
              <td style={{ border: "1px solid #ddd", padding: 10 }}>
                {row.installed}
              </td>
              <td style={{ border: "1px solid #ddd", padding: 10 }}>
                {row.latest}
              </td>
              <td style={{ border: "1px solid #ddd", padding: 10 }}>
                {row.stable}
              </td>
              <td style={{ border: "1px solid #ddd", padding: 10 }}>
                {row.hasUpdate ? "🔴 Update Available" : "🟢 Up to date"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PackageVersionDashboard;